"use client";

import MediaImage from "@/components/ui/MediaImage";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/sharp-light-svg-icons";
import { useRouter } from "next/navigation";
import RippleCtaButton from "../ui/RippleCtaButton";
const SearchImageSectionComponent: React.FC<
  SectionProps<{
    imageUrl: string;
    searchboxBgColor: string;
  }>
> = ({ cmsSection }) => {
  console.log(cmsSection);

  const [formData, setFormData] = React.useState({ q: "" });
  const router = useRouter();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const query = formData.q.trim() ?? "";
    setFormData({ q: "" });

    if (formData.q.trim()) {
      router.push(`/koeb?q=${encodeURIComponent(query)}`);
    } else {
      router.push(`/koeb`);
    }
  };

  return (
    <SectionLayout
      cmsSection={getDefaultCmsSection(cmsSection, {
        width: "full",
        padding: "none",
      })}
    >
      <div
        style={{ height: "625px" }}
        className="flex justify-center first:py-0 py-0.5 relative"
      >
        <MediaImage
          alt={"Image"}
          src={cmsSection.specifics.imageUrl}
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
          <div className="w-full max-w-[90%] lg:max-w-[70%] xl:max-w-[1026px]">
            <div
              style={{ backgroundColor: cmsSection.specifics.searchboxBgColor }}
              className="p-8 sm:p-12 lg:p-14 "
            >
              <form
                noValidate
                onSubmit={handleSubmit}
                className="w-full text-[var(--search-input-text)] p-2 flex gap-2"
              >
                <input
                  type="text"
                  id="q"
                  name="q"
                  className="p-3 w-full text-gray-800 focus:outline-none"
                  placeholder="Søg på sagsnr., by vej, postnr eller kommune"
                  value={formData.q}
                  onChange={handleChange}
                />
                <RippleCtaButton
                  className="whitespace-nowrap px-6"
                  type="submit"
                >
                  <span className="flex items-center gap-2">
                    <FontAwesomeIcon
                      className="size-[16px]"
                      icon={faMagnifyingGlass}
                    />
                    Søg
                  </span>
                </RippleCtaButton>
              </form>
            </div>
          </div>
        </div>
      </div>
    </SectionLayout>
  );
};

export default SearchImageSectionComponent;
